import ShareCard from "./ShareCard";

import useEmpanelment from "./useEmpanelment";

const DistributeNps = () => {
  const { onBoardingUrl, sipUrl, subsequentUrl } = useEmpanelment();

  const isEmpanelled = !!onBoardingUrl;

  return (
    <div className="container-margin">
      <div className="customer-support-email">
        Customer Support Email :{" "}
        <a href="mailto:npsdistributorsupport@kfintech.com">
          npsdistributorsupport@kfintech.com
        </a>
      </div>
      <div className="nps-head">
        Distribute National Pension System to your customers
      </div>
      {isEmpanelled ? (
        <>
          <ShareCard title="Customer Onboarding Link" url={onBoardingUrl} />
          <ShareCard title="For Subsequent Contribution" url={subsequentUrl} />
          {!!sipUrl && <ShareCard title="SIP" url={sipUrl} />}
        </>
      ) : (
        <div className="nps-message" style={{ textAlign: "center" }}>
          <h4>
            Your Customer Onboarding link will be generated after your
            empanelment registration is completed and successful.
          </h4>
        </div>
      )}
    </div>
  );
};

export default DistributeNps;
